import { Vector3 } from 'three';
import { EWall } from '../../@types/Enums';
import { DEFAULT_WALL_DEPTH, UNIT_TO_METER_DIVISOR } from '../../utils/constants';
import { calculateWallLength } from '../../utils/vectorUtils';
import Wall, { IWall } from '../abstract/Wall';
import { IAttribute } from './AttributeModel';
import { IDoor } from './DoorModel';
import { IPassage } from './PassageModel';
import { IRadiator } from './RadiatorModel';
import { IWindow } from './WindowModel';

export interface IPartitionWall extends IWall {
  sideLength: number;
  isOutOfBounds: boolean;
}

class PartitionWallModel extends Wall implements IPartitionWall {
  sideLength: number;

  isOutOfBounds: boolean;

  constructor(
    startPoint: Vector3,
    endPoint: Vector3,
    depth = DEFAULT_WALL_DEPTH,
    windows: Array<IWindow> = [],
    doors: Array<IDoor> = [],
    radiators: Array<IRadiator> = [],
    attributes: Array<IAttribute> = [],
    uuid: string | undefined = undefined,
    passages: Array<IPassage> = [],
  ) {
    super(startPoint, endPoint, depth, EWall.PARTITION, windows, doors, radiators, attributes, uuid, passages);
    this.isOutOfBounds = false;
    this.sideLength = this.calculateWallLength();
  }

  calculateWallLength() {
    return calculateWallLength(this.startPoint, this.endPoint) / UNIT_TO_METER_DIVISOR;
  }

  updateWallLengths() {
    this.sideLength = this.calculateWallLength();
  }

  getSideLength() {
    return this.sideLength;
  }

  setSideLength(sideLength: number) {
    this.sideLength = sideLength;
  }

  getIsOutOfBounds() {
    return this.isOutOfBounds;
  }

  setIsOutOfBounds(isOutOfBounds: boolean) {
    this.isOutOfBounds = isOutOfBounds;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      sideLength: this.sideLength,
      isOutOfBounds: this.isOutOfBounds,
    };
  }
}

export default PartitionWallModel;
